import type {FC} from 'react';

import styled, {css, keyframes} from 'styled-components';

import type {WithDomStyleProp} from '../../utils/utility-types';
import type {CircleProps, Props, StyledProps} from './types';

import {getColor} from '../../styles/utils';
import {web} from './styles';

const StyledLoadingSpinner = styled.div<StyledProps>`
  ${web}
`;

const outerCircleAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const innerCircleAnimation = keyframes`
  from {
    transform: rotate(360deg);
  }
  to {
    transform: rotate(0deg);
  }
`;

const animationConfig = css`
  animation-timing-function: linear;
  transform-origin: 50% 50%;
`;

const SOuterCircle = styled.circle.attrs<CircleProps>(p => ({
  stroke: getColor(p.stroke)(p),
}))`
  animation: ${outerCircleAnimation} 3s infinite;
  ${animationConfig}
`;

const SInnerCircle = styled.circle.attrs<CircleProps>(p => ({
  stroke: getColor(p.stroke)(p),
}))`
  animation: ${innerCircleAnimation} 3s infinite;
  ${animationConfig}
`;

const LoadingSpinner: FC<WithDomStyleProp<Props>> = ({
  size = 50,
  strokeInnerColor = 'global1',
  strokeOuterColor = 'global5',
  testID,
  ...rest
}) => {
  return (
    <StyledLoadingSpinner {...rest} data-test-id={testID}>
      <svg
        height={size}
        preserveAspectRatio="xMidYMid"
        viewBox="0 0 100 100"
        width={size}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <SOuterCircle
          cx="50"
          cy="50"
          fill="none"
          r="24"
          stroke={strokeOuterColor}
          strokeDasharray="37.69911184307752 37.69911184307752"
          strokeLinecap="round"
          strokeWidth="4"
          transform="rotate(211.505 50 50)"
        />
        <SInnerCircle
          cx="50"
          cy="50"
          fill="none"
          r="19"
          stroke={strokeInnerColor}
          strokeDasharray="29.845130209103033 29.845130209103033"
          strokeDashoffset="29.845130209103033"
          strokeLinecap="round"
          strokeWidth="4"
          transform="rotate(-211.505 50 50)"
        />
      </svg>
    </StyledLoadingSpinner>
  );
};

export {LoadingSpinner};
